import React, { useState, useEffect } from "react";
import { verifyPasswordResetCode, confirmPasswordReset, getAuth } from "firebase/auth";
// import { auth } from "./no/firebase";
import Swal from 'sweetalert2';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [oobCode, setOobCode] = useState('');
  const [email, setEmail] = useState(''); // Added email state
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const auth = getAuth();

  useEffect(() => {
    const code = searchParams.get('oobCode');
    if (code) {
      setOobCode(code);
      verifyPasswordResetCode(auth, code)
        .then((email) => {
          setIsValid(true);
          setEmail(email); // Set email when verifying the code
        })
        .catch((error) => {
          console.error("Error verifying code:", error);
          Swal.fire({
            icon: 'error',
            title: 'Invalid or expired action code',
            text: 'The action code is either invalid or expired. Please try again.'   ,
            customClass: {
              confirmButton: 'my-confirm-button', 
          }
          });
        });
    }
  }, [searchParams]);

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Passwords do not match',
        text: 'Please make sure both passwords are the same.',
        customClass: {
          confirmButton: 'my-confirm-button', 
      }
      });
      return;
    }
    if (!isValid) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid request',
        text: 'The reset code is not valid.',
        customClass: {
          confirmButton: 'my-confirm-button', 
      }
      });
      return;
    }

    try {
      const mailOptions = {
        to: email,
        message: {
            subject: "Your Password Has Been Changed",
            html: `<p>Hello,</p><p>We wanted to inform you that your password has been successfully changed. If you did not request this change, please contact us immediately.</p><p>Best regards,<br>The Spot Your Leads Team</p>`,
        },
    };

      await confirmPasswordReset(auth, oobCode, password);
      Swal.fire({
        icon: 'success',
        title: 'Password reset successful',
        text: 'Your password has been reset. You can now log in with the new password.',
        customClass: {
          confirmButton: 'my-confirm-button', 
      }
      }).then(
        await addDoc(collection(db, "mail"), mailOptions)

      )
      .then(() => {
        navigate('/SignIn'); // Redirect to login page after successful reset
      });
    } catch (error) {
      console.error("Error resetting password:", error);
      Swal.fire({
        icon: 'error',
        title: 'Password reset failed',
        text: 'An error occurred while resetting your password. Please try again later.',
        customClass: {
          confirmButton: 'my-confirm-button', 
      }
      });
    }
  };

  return (
    <section className="homeFourth formSection account">
      <Helmet>
                    <title>Spot Your Leads | Reset Password </title>
                </Helmet>  
    <h2>Reset Password</h2>
    <Container>
        <Row>
            <Col lg={11} md={11} sm={12}>
                <div className="formDiv mt-5">
                  <form 
                  onSubmit={handleSubmit}
                  >
                    <div>
                      <label htmlFor="password">New Password:</label>
                      <input
                        type="password"
                        id="password"
                        className="form-control"
                        value={password}
                        onChange={handlePasswordChange}
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="confirm_password">Confirm Password:</label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirm_password"
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        required
                      />
                    </div>
                    <button type="submit">Reset Password</button>
                  </form>
                </div>
             </Col>
             </Row>
             </Container>
      </section>

  );
}

export default ResetPassword;
